import React, { useEffect } from 'react'
import styled from 'styled-components'
import { trackEvent } from '@Utilities/marketingTags'
import GuestCards from '@Features/LandingPage/GuestLanding/GuestCards'
import InstructorsCarousel from '@Features/LandingPage/Components/InstructorsCarousel'
import FindClassroomSection from '@Features/LandingPage/GuestLanding/Components/FindClassroomSection'
import GuestLandingClassrooms from '@Features/LandingPage/GuestLanding/Components/GuestLandingClassrooms'
import Categories from '@Features/LandingPage/Components/Categories'
import Stats from '@Features/LandingPage/Components/Stats'
import NewsFeedsSection from '../Components/NewsFeedsSection/NewsFeedsSection'
import CTASection from '../Components/CTASection/CTASection'
import OfferSection from '../Components/OfferSection/OfferSection'
import FeaturedCoursesCarousel from '../Components/FeaturedCoursesCarousel'
import FeaturedBundlesCarousel from '../Components/FeaturedBundlesCarousel'
import Spacer from '@eduact/ed-components/Spacer'
import { useAppSelector } from '@Hooks/ReduxHooks'

const GuestLanding: React.FC = () => {
	const { instructor_section, subjects_section, classrooms_enabled } = useAppSelector(s => s.settings)

	// `/` renders a completely different tree for authed students
	// (StudentLanding) — this event marks the GUEST acquisition surface only.
	useEffect(() => {
		trackEvent('ViewContent', { content_name: 'guest_landing', content_category: 'lander' })
	}, [])

	return (
		<>
			<StyledGuestLandingContainer>
				<CTASection />
				<GuestLandingInnerContainer>
					{instructor_section && <InstructorsCarousel />}
					{classrooms_enabled && <FindClassroomSection />}
					<Spacer px={{ lg: '12.688rem' }} my={{ sm: '1.5rem', lg: '2rem' }}>
						<NewsFeedsSection />
					</Spacer>
					{classrooms_enabled && <GuestCards />}
					<FeaturedCoursesCarousel />
				<FeaturedBundlesCarousel />
					{classrooms_enabled && <GuestLandingClassrooms />}
					{subjects_section && <Categories />}
					<Stats />
					<OfferSection />
				</GuestLandingInnerContainer>
			</StyledGuestLandingContainer>
		</>
	)
}

const StyledGuestLandingContainer = styled.div`
	width: 100%;
`
const GuestLandingInnerContainer = styled.div`
	padding: 1rem;
	${({ theme }) => `${theme.mediaQueries.large}{
	padding: 26px 0;
	
}`}
`

export default GuestLanding
